// ##### Komarov 2025-07-22
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../../hooks/useLocalizedText.js';
import useValidateQuery from '../../../../../helpers/useValidateQuery';
import ItemContent from '../ItemContent/ItemContent';
import ItemObj from '../ItemObj/ItemObj';

// ##### Komarov 2025-07-22
const UlTag = ({ ulCLassName, width, divClassName, filtered, rate }) => {
  // ##### Komarov 2025-08-05
  const searchReturnedNoResults = useLocalizedText('SearchReturnedNoResults');
  const search_data = useValidateQuery();

  return (
    <ul
      data-component="UlTag"
      className={ulCLassName}
      style={{
        width: `${width}px`,
      }}
    >
      <>
        {filtered.length > 0 && filtered ? (
          filtered.map(tour => {
            return (
              <li key={tour.tour_id} className="descriptionLi">
                {rate ? (
                  rate.map(tariff => {
                    if (parseInt(tour.tour_id) === parseInt(tariff.tour_id)) {
                      return (
                        <>
                          <h3
                            style={{
                              fontSize: '27px',
                              color: '#001959',
                            }}
                          >
                            {tour.tour_name}
                          </h3>
                          {/* ##### 23-02-22 Komarov */}
                          <div className={divClassName}>
                            <ItemContent tour={tour} />

                            <ItemObj
                              key={parseInt(tariff.tour_id)}
                              tariff={tariff}
                              searchResults={search_data}
                              history={history}
                              tour_name={tour.tour_name}
                              pickedCurrency={search_data.selected_currency}
                            />
                          </div>
                        </>
                      );
                    }
                  })
                ) : (
                  // ##### 24-03-21 Komarov
                  <button type="button" className="onrequestButton">
                    Sold out
                  </button>
                )}
                {/* </div> */}
              </li>
            );
          })
        ) : (
          <div className="noResultSearch">
            {/* ##### 23-09-07 Komarov */}
            {searchReturnedNoResults}
          </div>
        )}
      </>
    </ul>
  );
};

export default UlTag;
